import { useState } from 'react'

/**
 * Управление выделением медиа (чекбоксы).
 */
export default function useMediaSelection() {
  const [selectedIds, setSelectedIds] = useState(new Set())

  function toggleMediaSelection(mediaId) {
    setSelectedIds((prev) => {
      const next = new Set(prev)
      if (next.has(mediaId)) next.delete(mediaId)
      else next.add(mediaId)
      return next
    })
  }

  function clearSelection() {
    setSelectedIds(new Set())
  }

  return {
    selectedIds,
    hasSelection: selectedIds.size > 0,
    toggleMediaSelection,
    clearSelection,
  }
}
